import { Box, DialogActions, DialogContent, DialogProps, Typography } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import partnerImg from '../assets/images/partner.svg';

import Button from './button';
import Dialog from './dialog';

function PartnerDialog({
  partner,
  onClose,
  ...props
}: Omit<DialogProps, 'onClose'> & {
  onClose: () => void;
  partner: { title?: string };
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog fullWidth maxWidth="sm" onClose={onClose} {...props}>
      <DialogContent
        sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        <img height={150} src={partnerImg} />
        <Typography align="center" fontSize="1.1rem" fontWeight={600}>
          <Trans
            components={[<br key={0} />]}
            i18nKey="geovelo.partner_dialog.title"
            values={{ partner: partner.title }}
          />
        </Typography>
        <Box alignSelf="stretch" display="flex" flexDirection="column" gap={1}>
          <Typography>{t('geovelo.partner_dialog.subtitle')}</Typography>
          <Typography
            component="ul"
            sx={({ palette }) => ({
              listStyle: 'none',
              'li::before': {
                color: palette.secondary.main,
                content: "'\\2022'",
                display: 'inline-block',
                marginLeft: '-1em',
                fontWeight: 700,
                width: '1em',
              },
            })}
          >
            <Trans
              components={[<li key={0} />, <li key={1} />, <li key={2} />]}
              i18nKey="geovelo.partner_dialog.text"
            />
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} size="small">
          {t('commons.actions.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PartnerDialog;
